import classNames from "classnames"
import { node, string } from "prop-types"

SuccessMessage.propTypes = {
  children: node,
  className: string,
}

export function SuccessMessage({
  children,
  className: classNameProp = "",
  ...rest
}) {
  const className = classNames("success-alert alert", classNameProp)

  return (
    <div {...rest} className={className}>
      {children}
    </div>
  )
}
